module.exports = __webpack_public_path__ + "static/media/how-we-hire-phn.b98239cf.webp";